import {css} from '@emotion/core'
import styled from '@emotion/styled'
import {marketingMobileCuttoff, white} from "@css/constants";
import {FontNormal} from "@css/fonts";

export const HeroImageContainer = styled('div')(css`
  height: 400px;
  background-image: url(https://d2lmu8mdsta5zy.cloudfront.net/img/careers-banner-gradient.jpg);
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  @media(max-width: ${marketingMobileCuttoff}) {
    text-align: center;
    padding: 30px;
  }
`)

export const HeroImageTextWrapper = styled('div')(css`
  padding-top: 160px;
  max-width: 600px;
  text-align: center;
  min-width: 100%;
  
  @media(max-width: ${marketingMobileCuttoff}) {
    padding-top: 150px;
  }
`)

export const HeroImageTitle = styled('h1')(css`
  font-size: 44px;
  ${FontNormal(600)};
  letter-spacing: 3px;
  text-transform: uppercase;
  padding-bottom: 40px;
  color: ${white};
  
  @media(max-width: ${marketingMobileCuttoff}) {
    font-size: 32px;
  }
`)

export const HeroImageButton = styled('a')(css`
  cursor: pointer;
  background-color: ${white};
  color: #5ecd82;
  ${FontNormal(600)};
  border-radius: 5px;
  font-size: 18px;
  width: auto;
  padding: 12px 50px;
  text-transform: none;
  text-decoration: none;
`)
